<div class="main-container">
    <br><br>
    <h1 class="title" style="text-align: center;">AIR RECEIVER TANK</h1>
    <div class="carousel-container">
        <div id="compressorCarousel" class="carousel slide" data-ride="carousel">
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <img src="../../../assets/img/slides img/air-receiver-tank.jpeg" style="border-radius: 15px; box-shadow: 10px;"  height="350px" width="350px">
                </div>
            </div>
        </div>
    </div>
   
    <p class="tagline" style="text-align: center;">Essential for Storing, Regulating, and Enhancing Compressed Air Systems</p>
    <p class="tagline1">
        <li>An air receiver tank acts as a storage vessel for compressed air, ensuring a steady supply to meet varying demand levels in industrial processes.</li>
    </p>
    <p class="tagline1">
        <li>It helps regulate pressure fluctuations, reducing the strain on air compressors and enhancing the overall efficiency of the system.</li>
    </p>
    <p class="tagline1">
        <li>Air receiver tanks also act as a buffer for sudden surges in air usage, preventing drops in air pressure that could impact machinery performance.</li>
    </p>
    <p class="tagline1">
        <li>These tanks assist in separating oil and moisture from the compressed air before it reaches the air dryer, ensuring cleaner and drier air.</li>
    </p>
    <p class="tagline1">
        <li>Available in vertical and horizontal configurations, air receiver tanks are designed to fit various space constraints and operational needs.</li>
    </p>
    <p class="tagline1">
        <li>By providing a reserve of compressed air, air receiver tanks contribute to reduced energy consumption and extended compressor lifespan.</li>
    </p>
    <p class="tagline1">
        <li>They are widely used in industries such as manufacturing, automotive, and food processing, where reliable compressed air is essential for daily operations.</li>
    </p>
    <br><br>

    
    <div class="service-highlights">
        <div class="container">
            <div class="section-header text-center">
                <h2 class="font-weight-bold">OUR SERVICES</h2>
                <p class="section-description"><i class="fa fa-arrow-right"></i>Explore our range of top-notch services designed to meet your needs.</p>
            </div>
            <div class="row">
                <!-- Service Card 1 -->
                <div class="col-md-4 service-card">
                    <div class="service-image">
                        <h4 class="font-weight-bold" style="text-align: center;">Custom Repairs</h4>
                        <img src="../../../assets/img/active-product/animationproduct12.webp" alt="Service 1" class="img-fluid">
                    </div>
                    <div class="service-content">
                        <br>
                        <p class="service-description"><i class="fa fa-arrow-right"></i>Get personalized repair solutions tailored to your specific requirements.</p>
                    </div>
                </div>
                <!-- Service Card 2 -->
                <div class="col-md-4 service-card">
                    <div class="service-image">
                        <h4 class="font-weight-bold" style="text-align: center;">Maintenance Packages</h4>
                        <img src="../../../assets/img/active-product/animationproduct13.png"  alt="Service 2" class="img-fluid">
                    </div>
                    <div class="service-content">
                        <br>
                        <p class="service-description"><i class="fa fa-arrow-right"></i>Ensure the longevity of your assets with our affordable maintenance plans.</p>
                    </div>
                </div>
                <!-- Service Card 3 -->
                <div class="col-md-4 service-card">
                    <div class="service-image">
                        <h4 class="font-weight-bold" style="text-align: center;">Emergency Support</h4>
                        <img src="../../../assets/img/active-product/animationproduct10.jpg" alt="Service 3" class="img-fluid">
                    </div>
                    <div class="service-content">
                        <br>
                        <p class="service-description"><i class="fa fa-arrow-right"></i>Count on us for quick and reliable solutions during critical times.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
<br>
    <div class="contact-info">
        <a href="tel:8489359948" class="contact-btn phone-btn">
          <span class="fa fa-phone"></span> Call Now
        </a>
        <a href="mailto:rvproduction2017@gmail.com" class="contact-btn email-btn">
          <span class="fa fa-envelope"></span> Email Us
        </a>
        <a href="https://wa.me/8489359948" target="_blank" class="contact-btn whatsapp-btn">
          <span class="fa fa-whatsapp"></span> WhatsApp
        </a>
      </div>

</div>
